import { AwardInfo, AwardsApi, CaseStudiesApi, CaseStudyInfo, useAuthContext } from "@pull/pull-groupm-csp-api"
import { Tab } from "bootstrap"
import { FC, useEffect, useState } from "react"
import { useQuery } from "react-query"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Column } from "react-table"
import { SwapperComponent } from "../../../_metronic/assets/ts/components"
import { KTCard, KTCardBody } from "../../../_metronic/helpers"
import { PageLink, PageTitle } from "../../../_metronic/layout/core"
import { ToolbarContainer } from "../../../_metronic/layout/core/ToolbarContainer"
import { QUERIES } from "../../Constants/Queries"
import PageContainer from "../../helpers/components/listing/PageContainer"
import { EditModalProvider } from "../../modules/core/functional/EditModalContext"
import { TableProvider } from "../../modules/core/functional/TableContext"
import { LoadingComponent } from "../../modules/core/LoadingComponent"
import { AwardHistoryCard } from "./history/AwardsHistoryCard"
import { AwardModalWrapper } from "./modals/AwardModalWrapper"
import AwardTabs from "./tabs/AwardTabs"
import { DownloadSubmissionsModalProvider } from "./modals/DownloadSubmissionsModalContext"
import { DownloadSubmissionsModal } from "./modals/DownloadSubmissionsModal"
import { AwardSubmissionWinnerModalProvider } from "./modals/AwardSubmissionWinnerModalContext"
import { AwardSubmissionWinnerModal } from "./modals/AwardSubmissionWinnerModal"
import { AwardSubmissionWinnerModalWrapper } from "./modals/AwardSubmissionWinnerModalWrapper"



const baseFilters = {
    pending: false,
    openForSubmissions: true,
    openForJudging: false,
    openForDeliberations: false,
    closed: false,
    pageSize: 10,
    year: null
}

const AwardsCategoryPage: FC = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    if (!Number(id)) {
        navigate("/404")
    }
    const { getApiConfiguration } = useAuthContext()
    const awardsApi = new AwardsApi(getApiConfiguration())
    const { isLoading, data: awardCat } = useQuery([QUERIES.AWARDS.GET_CATEGORY + Number(id)], () => awardsApi.apiAwardsAwardCategoriesIdGet(Number(id)), { refetchOnWindowFocus: false, cacheTime: 3000 })

    const awardsInTab = async (page: number, filters: any) => {
        return awardsApi.apiAwardsAwardsSearchPost({ ...filters, selectedAwardCategories: [awardCat?.id], page: page })
    }

    if (isLoading)
        return <LoadingComponent />

    const awardCategoryBreadcrumbs: Array<PageLink> = [
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
        {
            title: awardCat?.name ?? "Award Category",
            path: `/awards/${id}`,
            isSeparator: false,
            isActive: false,
        },
    ]



    return (
        <>
            <DownloadSubmissionsModalProvider>
                <AwardSubmissionWinnerModalProvider>
                    <AwardSubmissionWinnerModalWrapper />
                    <DownloadSubmissionsModal />
                    <AwardModalWrapper />
                    <ToolbarContainer>
                        <PageTitle breadcrumbs={awardCategoryBreadcrumbs} title={awardCat?.name} />
                        <div className="d-flex align-items-center py-3 py-md-1">
                            <Link to={`/awards/${id}/details`} className="btn btn-sm btn-dark fw-bold">
                                <span className="svg-icon svg-icon-2">
                                    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                        <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M2 4.63158C2 3.1782 3.1782 2 4.63158 2H13.47C14.0155 2 14.278 2.66919 13.8778 3.04006L12.4556 4.35821C11.9009 4.87228 11.1726 5.15789 10.4163 5.15789H7.1579C6.05333 5.15789 5.15789 6.05333 5.15789 7.1579V16.8421C5.15789 17.9467 6.05333 18.8421 7.1579 18.8421H16.8421C17.9467 18.8421 18.8421 17.9467 18.8421 16.8421V13.7518C18.8421 12.927 19.1817 12.1387 19.7809 11.572L20.9878 10.4308C21.3703 10.0691 22 10.3403 22 10.8668V19.3684C22 20.8218 20.8218 22 19.3684 22H4.63158C3.1782 22 2 20.8218 2 19.3684V4.63158Z" fill="currentColor"></path>
                                        <path d="M10.9256 11.1882C10.5351 10.7977 10.5351 10.1645 10.9256 9.77397L18.0669 2.6327C18.8479 1.85165 20.1143 1.85165 20.8953 2.6327L21.3665 3.10391C22.1476 3.88496 22.1476 5.15129 21.3665 5.93234L14.2252 13.0736C13.8347 13.4641 13.2016 13.4641 12.811 13.0736L10.9256 11.1882Z" fill="currentColor"></path>
                                        <path d="M8.82343 12.0064L8.08852 14.3348C7.8655 15.0414 8.46151 15.7366 9.19388 15.6242L11.8974 15.2092C12.4642 15.1222 12.6916 14.4278 12.2861 14.0223L9.98595 11.7221C9.61452 11.3507 8.98154 11.5055 8.82343 12.0064Z" fill="currentColor"></path>
                                    </svg>
                                </span>
                                Category settings
                            </Link>
                        </div>
                    </ToolbarContainer>
                    <PageContainer>
                        <TableProvider baseFilter={{ ...baseFilters, selectedAwardCategories: [awardCat?.id] }}>
                            <AwardTabs getData={awardsInTab} query={QUERIES.AWARDS.SEARCH + Number(id)} />
                        </TableProvider>
                        <AwardHistoryCard categoryId={Number(id)} />
                    </PageContainer>
                </AwardSubmissionWinnerModalProvider>
            </DownloadSubmissionsModalProvider>
        </>
    )
}

const AwardCategoryPageWrapper = () => {
    return (
        <EditModalProvider>
            <AwardsCategoryPage />
        </EditModalProvider>
    )
}


export { AwardsCategoryPage, AwardCategoryPageWrapper }